import * as React from 'react'
// components
import { DrawerModal } from 'components/UI'
// context
import { SecurityProfilesContext } from 'containers/Security/components/SecurityProfiles/layers/API'
// constants
import { Modals } from 'constants/modals'
import { PROFILE_SELECT_OPTIONS, SECURITY_PROFILE_INITIAL_VALUES } from 'constants/security'
// hooks
import { useModalData } from 'hooks/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { Header } from 'components/Modals/PlanItems/styles'
// view components
import SecurityProfileForm from './Form'
// utils
import { getOptionByValue } from 'utils/form'

const PAPER_PROPS = {
  style: {
    height: '100%',
    overflow: 'hidden',
    top: 0
  }
}

const SecurityProfileModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, isEdit, profile }
  } = useModalData({ modalType: Modals.SECURITY_PROFILE_MODAL })

  const { createSecurityProfile, updateSecurityProfile } = React.useContext(SecurityProfilesContext)

  const handleFormSubmit = async (data) =>
    isEdit ? await updateSecurityProfile(profile.id, data, hideModal) : await createSecurityProfile(data, hideModal)

  const normalizeSecurityProfileData = (data) => {
    const normalizedData = { ...data }

    Object.keys(normalizedData).forEach((key) => {
      const value = normalizedData[key]

      if (typeof value === 'string') {
        return (normalizedData[key] = getOptionByValue(value, PROFILE_SELECT_OPTIONS))
      }
    })

    return normalizedData
  }

  const permissions = profile ? normalizeSecurityProfileData(profile.permissions) : {}

  const initialValues = isEdit
    ? {
        active: profile.active,
        name: profile.name,
        ...permissions
      }
    : SECURITY_PROFILE_INITIAL_VALUES

  return (
    <DrawerModal width={'600px'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <Header>
        <span>{`${isEdit ? 'Edit' : 'Create'} Profile`}</span>
        <CloseIcon onClick={hideModal} />
      </Header>
      <SecurityProfileForm
        hideModal={hideModal}
        initialValues={initialValues}
        isEdit={isEdit}
        onSubmit={handleFormSubmit}
        profile={profile}
      />
    </DrawerModal>
  )
}

export default SecurityProfileModal
